module.exports = __webpack_public_path__ + "media/images/icon_job-e984593f0c75b8087c867fb06581e47d.png";